import { setRequest } from '@sancare/typescript-commons/src/misc/api'

import {
  convertHomeChartStatIn,
  convertHomeStatsIn,
  convertPredictionModelIn,
  HomeChartStatDtoIn,
  HomeStatsDtoIn,
  PredictionModelDtoIn,
} from '@/home/store/dto'
import { HomeState } from '@/home/store/state'
import { EMPTY_HOME_STATS } from '@/home/types'

export const mutations = {
  getHomeStatsSuccess(state: HomeState, rawStats: HomeStatsDtoIn) {
    state.homeStats = convertHomeStatsIn(rawStats)
  },
  getHomeStatsError(state: HomeState) {
    state.homeStats = { ...EMPTY_HOME_STATS }
  },
  getHomeChartStatsSuccess(state: HomeState, rawChartStats: HomeChartStatDtoIn[]) {
    state.homeChartStats = rawChartStats.map((rawChartStat) => convertHomeChartStatIn(rawChartStat))
  },
  getHomeChartStatsError(state: HomeState) {
    state.homeChartStats = []
  },
  getPredictionModelsSuccess(state: HomeState, rawPredictionModels: PredictionModelDtoIn[]) {
    state.predictionModels = rawPredictionModels.map((rawPredictionModel) => convertPredictionModelIn(rawPredictionModel))
  },
  getPredictionModelsError(state: HomeState) {
    state.predictionModels = []
  },
  setRequest,
}
